import { ReactNode } from "react";
import clsx from "clsx";

type Props = {
  children: ReactNode;
  isOpacityMode?: boolean;
};

export default function ChatHeader({ children, isOpacityMode }: Props) {
  return (
    <div
      className={clsx(
        "h-[2.625rem] bg-gradient-to-r  flex gap-1 rounded-[0.5rem] p-0.5",
        isOpacityMode ? "from-dark-900/60 to-transparent" : "from-dark-900/80 to-dark-900/60",
      )}
    >
      {children}
    </div>
  );
}
